<template>
    <div class="player-navigation">
        <b-button
            variant="transparent"
            class="mr-1 backward"
            :title="$translate(backTitle)"
            @click.stop.prevent="jump(false)"
        >
            <i class="fa fa-step-backward" />
        </b-button>

        <b-button
            :pressed="playState === 'play'"
            variant="transparent"
            class="play"
            :title="$translate(playButtonIcon)"
            @click.stop.prevent="togglePlay"
        >
            <i :class="`fa fa-${playButtonIcon}`" />
        </b-button>

        <b-button
            variant="transparent"
            class="mr-1 forward"
            :title="$translate(forwardTitle)"
            @click.stop.prevent="jump(true)"
        >
            <i class="fa fa-step-forward" />
        </b-button>
    </div>
</template>

<script>
export default {
    name: 'PlayerNavigation',
    props: {
        playState: {
            type: String,
            required: true
        },
        videoSeekMode: {
            type: String,
            required: true
        }
    },
    computed: {
        playButtonIcon() {
            return this.playState === 'play' ? 'pause' : 'play'
        },
        backTitle() {
            return this.videoSeekMode === 'time' ? 'skip_backward' : 'skip_event_backward'
        },
        forwardTitle() {
            return this.videoSeekMode === 'time' ? 'skip_forward' : 'skip_event_forward'
        }
    },
    methods: {
        togglePlay() {
            this.$emit('playToggled', this.playState === 'play' ? 'pause' : 'play')
        },
        jump(isForward) {
            this.$emit('skipClicked', isForward)
        }
    }
}
</script>

<style lang="scss" scoped>
.player-navigation {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-around;

    .play {
        margin: 0 0.5rem;
    }
}
</style>
